{
  "Approve": "Approve",
  "DeleteReminder": "Delete reminder",
  "DismissAlert": "Dismiss",
  "DismissReminder": "Dismiss reminder",
  "EditReminder": "Edit reminder",
  "High": "High",
  "Reject": "Reject",
  "RemindMe15Min": "Remind me in 15 minutes",
  "RemindMe5Min": "Remind me in 5 minutes",
  "RemindMe60Min": "Remind me in an hour",
  "RemindMeTomorrow": "Remind me tomorrow",
  "Snooze": "Remind me",
  "markAsRead": "Mark as read",
  "markAsUnread": "Mark as unread"
} 
